import React from 'react';
import cn from 'classnames';
import * as Fi from 'react-icons/fi';
import { Select } from 'ui/components';

const Filter = ({ show, onClose, JobTable, setCount }) => {
  const handleFilter = async (e) => {
    if (JobTable?.State?.filter) {
      let x = [];
      Object.keys(JobTable?.State?.filter).forEach((k) => {
        if (
          JobTable?.State?.filter[k] &&
          k !== 'destination_village_postalcode' &&
          k !== 'status' &&
          k !== 'type'
        ) {
          x.push(k);
        }
      });
      setCount(x);
    }
  };

  React.useEffect(() => {
    handleFilter();
  }, []);

  return (
    <>
      <div
        className={cn(
          show
            ? 'col-md-3 d-none d-md-block py-3 px-3 m-0 border-start'
            : 'd-none'
        )}
      >
        <div className="mb-3 border-bottom">
          <div className="d-flex align-items-center justify-content-between">
            <div className="page-pretitle fs-7 text-secondary">Filter</div>
            <div className="mt-n1">
              <button className="btn btn-action-close " onClick={onClose}>
                <Fi.FiX color="hsl(0deg 0% 81%)" size={18} />
              </button>
            </div>
          </div>
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">Provinsi</div>
          <Select.Remote
            placeholder=""
            url="/region/province"
            initialValue={JobTable.State?.filter?.destination_province_id}
            row={(d) => {
              return { value: d?.province_id, label: d?.province_name };
            }}
            onSelected={(c) => {
              JobTable.filter('destination_province_id', c?.province_id);
              handleFilter();
            }}
          />
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">Wilayah</div>
          <Select.Remote
            placeholder=""
            url="/region"
            initialValue={JobTable.State?.filter?.destination_village_id}
            params={{
              search: JobTable.State?.filter?.destination_village_postalcode,
            }}
            row={(d) => {
              return {
                value: d.village_id,
                label: `${d.village_name}, ${d.district_name}, ${d.regency_name}, ${d?.province_name} ${d.postal_code} `,
              };
            }}
            onSelected={(c) => {
              JobTable.filter('destination_village_id', c?.village_id);
              JobTable.filter('destination_village_postalcode', c?.postal_code);
              handleFilter();
            }}
          />
        </div>
      </div>

      <>
        <div
          className={cn('filter-overlay', show ? 'd-block d-md-none' : '')}
          onClick={onClose}
        />
        <div
          className={cn(
            'filter-modal d-block d-md-none py-3',
            show ? 'filter-show' : ''
          )}
        >
          <div className="mb-3 border-bottom">
            <div className="d-flex align-items-center justify-content-between">
              <div className="page-pretitle fs-7 text-secondary">Filter</div>
              <div className="mt-n1">
                <button className="btn btn-action-close " onClick={onClose}>
                  <Fi.FiX color="hsl(0deg 0% 81%)" size={18} />
                </button>
              </div>
            </div>
          </div>

          <div className="mb-3">
            <div className="page-pretitle text-secondary mb-2">Provinsi</div>
            <Select.Remote
              placeholder=""
              url="/region/province"
              initialValue={JobTable.State?.filter?.destination_province_id}
              row={(d) => {
                return { value: d?.province_id, label: d?.province_name };
              }}
              onSelected={(c) => {
                JobTable.filter('destination_province_id', c?.province_id);
                handleFilter();
              }}
            />
          </div>

          <div className="mb-3">
            <div className="page-pretitle text-secondary mb-2">Wilayah</div>
            <Select.Remote
              placeholder=""
              url="/region"
              initialValue={JobTable.State?.filter?.destination_village_id}
              params={{
                search: JobTable.State?.filter?.destination_village_postalcode,
              }}
              row={(d) => {
                return {
                  value: d.village_id,
                  label: `${d.village_name}, ${d.district_name}, ${d.regency_name}, ${d?.province_name} ${d.postal_code} `,
                };
              }}
              onSelected={(c) => {
                JobTable.filter('destination_village_id', c?.village_id);
                JobTable.filter(
                  'destination_village_postalcode',
                  c?.postal_code
                );
                handleFilter();
              }}
            />
          </div>
        </div>
      </>
    </>
  );
};

export default Filter;
